export { default as withQueryChannel } from './withQueryChannel';
export { default as withQueryPointOfSales } from './withQueryPointOfSales';
export { default as withQueryUser } from './withQueryUser';
export { default as withQueryProducts } from './withQueryProducts';
export { default as withQueryProduct } from './withQueryProduct';
export { default as withQueryPayment } from './withQueryPayment';
export { default as withQueryTax } from './withQueryTax';
export { default as withQueryOrders } from './withQueryOrders';
export { default as withQueryPreOrders } from './withQueryPreOrders';
export { default as withQueryMembers } from './withQueryMembers';



// WEBPACK FOOTER //
// ./src/model/Queries/index.js